import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import "../../Form.css";
import "../../File.css";
import Appointment from "../../Appointment/Appointment";
import NavbarAdministration from "../NavbarAdministration";
import vars from "../../../utils/variables";

const AppointmentsAdministration = props => {
  const [api, setApi] = useState({ appointments: [] });

  useEffect(() => {
    async function fetchData() {
      const res = await fetch(`${vars.server}/administration/allappointments`, {
        credentials: "include"
      });
      res.json().then(res => {
        if (res.success) {
          setApi(res);
        } else if (res.subject === "NotAuthenticated") {
          props.history.push("/login");
        } else if (res.subject === "NotAuthorized") {
          props.history.push("/notauthorized");
        }
      });
    }
    fetchData();
  }, [props]);

  return (
    <div className="Administration">
      <NavbarAdministration />
      <h1>Alle Termine</h1>
      <div className="Admin">
        <ul className="tableHead">
          <li className="spaceOne">Datum</li>
          <li className="spaceTwo">Ort</li>
          <li className="spaceThree">Beschreibung</li>
          <li className="spaceFour">Zugriff</li>
        </ul>
        <ul>
          {api.appointments.map((appointment, index) => (
            <Appointment key={index} data={appointment} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default withRouter(AppointmentsAdministration);
